import React, { useState, useRef } from "react";
import axios from "axios";

import PropTypes from "prop-types";
import Modal from "./Modal";
import Button from "./Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
const ModalTeam = ({
  content,
  isOpen,
  onClose,
  startButton,
  leaveButton,
  onStart,
  headerBg,
  headerColor
}) => {
  const { t } = useTranslation();
  const [teamName, setTeamName] = useState("");
  const [teamMemberName, setTeamMemberName] = useState("");
  const [memberList, setMemberList] = useState([]);
  const [isFirstSetup, setIsFirstSetup] = useState(true);

  const headerStyle = {
    color: headerColor,
    background: headerBg
  };

  const memberListNode = useRef();

  const onInsertMember = (e, teamMemberName) => {
    e.preventDefault();
    const filterSameName = memberList.find(item => item === teamMemberName);

    if (teamMemberName !== filterSameName) {
      setMemberList([...memberList, teamMemberName]);
      setTeamMemberName("");
    } else {
      window.alert("Sorry, you are not allowed to enter existing username");
    }
  };

  const onRemoveMember = member => {
    setMemberList(memberList.filter(item => item !== member));
  };

  const handleOnStart = () => {
    // Prevent onStart when the Modal is hidden
    if (!isOpen) return null;

    const members = memberList;

    // Prevent update feed on update team (only on first setup)
    if (isFirstSetup) {
      axios.post("/wp-json/api/v1/update_feed").catch(console.error);
      setIsFirstSetup(false);
    }

    onStart(members);
  };

  return (
    <>
      <Modal
        className="team"
        isOpen={isOpen}
        onClose={onClose}
        isWithCloseButton={false}
      >
        <div className="modal-team">
          <div className="modal-team-header" style={headerStyle}>
            <div className="modal-team-header__left">
              <div className="modal-lamp-container">
                <div className="modal-lamp-item-left" />
                <div className="modal-lamp-effect" />
                <img
                  src="/wp-content/themes/teamconnector2/assets/images/lightoff.png"
                  alt="modal lamp"
                />
              </div>
            </div>
            <div className="modal-team-header__title">
              <h2>
                {memberList.length === 0
                  ? t("Create a Team")
                  : t("Change Team Member")}
              </h2>
            </div>
            <div className="modal-team-header__close-button">
              <button onClick={onClose} className="button-text">
                <h5>{t("Close")}</h5>
              </button>
              <div className="modal-lamp-container">
                <div className="modal-lamp-item-right" />
                <div className="modal-lamp-effect" />
                <img
                  src="/wp-content/themes/teamconnector2/assets/images/lightoff.png"
                  alt="modal lamp"
                />
              </div>
            </div>
          </div>
          <div className="modal-team-body">
            <div
              className="modal-team-body__welcome-text"
              dangerouslySetInnerHTML={{ __html: content }}
            />
            <div className="modal-team-form">
              <div className="modal-team-form__team-name">
                <input
                  placeholder={t("Team Name")}
                  value={teamName}
                  onChange={e => setTeamName(e.target.value)}
                />
              </div>
              <form type="submit" className="modal-team-form__team-member">
                <div className="modal-team-form__team-member-form">
                  <input
                    placeholder={t("Inset member name")}
                    value={teamMemberName}
                    onChange={e => setTeamMemberName(e.target.value)}
                  />
                  <button
                    type="submit"
                    className="member-insert-button"
                    onClick={e => onInsertMember(e, teamMemberName)}
                  >
                    <FontAwesomeIcon icon={["far", "edit"]} />
                  </button>
                </div>

                <div
                  ref={memberListNode}
                  className="modal-team-form__team-member-submitted"
                >
                  {memberList.map((member, index) => {
                    return (
                      <div key={index} className="member-list-item">
                        {member}{" "}
                        <div
                          onClick={() => onRemoveMember(member)}
                          className="remove-member-list-item"
                        >
                          {" "}
                          <FontAwesomeIcon icon={["far", "times"]} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </form>

              <div className={`modal-team-body__cta `}>
                <Button className="leave" {...leaveButton} />
                <Button
                  {...startButton}
                  className="modal-team-start"
                  onClick={handleOnStart}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* <div className={clsx("teamname", !isOpen && "is-open")}>
        <h5 className="teamname-title">Team Name</h5>
        <p className="teamname-value">{teamName}</p>
      </div> */}
    </>
  );
};

ModalTeam.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  teamMembers: PropTypes.array,
  content: PropTypes.string,
  formTitle: PropTypes.string,
  isOpen: Modal.propTypes.isOpen,
  onClose: Modal.propTypes.onClose,
  inputTotal: PropTypes.number,
  startButton: PropTypes.shape(Button.propTypes),
  onStart: PropTypes.func
};

ModalTeam.defaultProps = {
  inputTotal: 1,
  onStart: members => {}
};

export default ModalTeam;
